import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { Dispatch, SetStateAction } from 'react'
import { faBars, faMoon, faSun } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { DarkModeContext } from '../../../providers/DarkModeProvider'
import UserDropdown from './user-dropdown/UserDropdown'
import './Header.css'

interface HeaderProps {
  sidebar: {
    get: boolean
    set: Dispatch<SetStateAction<boolean>>
  }
}

function Header(props: HeaderProps) {
  // Red header on development, blue in production, so the two are told apart at a glance.
  const isDev = process.env.NODE_ENV === 'development'
  const navbarVariant = isDev ? 'bg-danger' : 'bg-primary'

  const { isDarkMode, toggleDarkMode } = React.useContext(DarkModeContext)

  return (
    <nav className={`app-header navbar navbar-expand navbar-accent border-bottom-0 ${navbarVariant}`}>
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              onClick={() => props.sidebar.set(prev => !prev)}
              type="button"
              className="nav-link"
            >
              <FontAwesomeIcon icon={faBars as IconProp} />
            </button>
          </li>
          <li className="nav-item">
            <button
              onClick={toggleDarkMode}
              type="button"
              className="nav-link"
            >
              {isDarkMode
                ? (
                    <FontAwesomeIcon icon={faSun as IconProp} />
                  )
                : (
                    <FontAwesomeIcon icon={faMoon as IconProp} />
                  )}
            </button>
          </li>
        </ul>
        <ul className="navbar-nav ms-auto">
          <UserDropdown />
        </ul>
      </div>
    </nav>
  )
}

export default Header
